import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Loading indicator service. Connected to the loader in the app component, which displays a loader over the entire application
 */
@Injectable({
  providedIn: 'root'
})
export class AppLoadingIndicatorService {
  /**
   * BehaviorSubject managing the show / loading state
   */
  private _show$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Observable that can be subscribed to
   */
  public show$: Observable<boolean> = this._show$.asObservable();

  /**
   * Shows the loading indicator
   */
  public show(): void {
    this._show$.next(true);
  }

  /**
   * Hides the loading indicator
   */
  public hide() {
    this._show$.next(false);
  }
}
